import { merge } from "lodash";
export * from "./baseConst";
import { ROUTE_URL as BASE_ROUTE_URL, URL_PREFIX } from "./baseConst";
import { FIELDS } from "./form/fields";
import featureToggles from "../../config/feature-toggles.malaysia";

const listingRoute: {
  listingType?: string;
  location: string;
  propertyDetail: string;
  facilities: string;
  description: string;
  media: string;
  upgrade: string;
  confirmation: string;
} = {
  listingType: URL_PREFIX + "/edit-listing/listing-details/",
  location: URL_PREFIX + "/edit-listing/location/",
  propertyDetail: URL_PREFIX + "/edit-listing/property-details/",
  facilities: URL_PREFIX + "/edit-listing/facilities/",
  description: URL_PREFIX + "/edit-listing/description-and-media/",
  media: URL_PREFIX + "/edit-listing/description-and-media/",
  upgrade: URL_PREFIX + "/edit-listing/upgrade-and-review/",
  confirmation: URL_PREFIX + "/edit-listing/confirmation/",
};

if (featureToggles.LSOT) {
  delete listingRoute.listingType;
}

export const ROUTE_URL = merge(BASE_ROUTE_URL, {
  addListing: {
    firstStep: featureToggles.LSOT
      ? URL_PREFIX + "/add-listing/location"
      : URL_PREFIX + "/add-listing/listing-details",
  },
  overviewURL: URL_PREFIX + "/listing/overview",
  listing: listingRoute,
});

export const AUPURL = {
  "en-GB":
    "https://www.iproperty.com.my/acceptable-use-policy-developer-other-advertisers/",
};

export const FIELD_ERRORS: { [key: string]: { step: string; field: string } } =
  {
    CHANNEL_TYPE_MANDATORY: {
      step: "listingDetails",
      field: "stepOfListingType.channel.label",
    },
    PROPERTY_TYPE_MANDATORY: {
      step: "listingDetails",
      field: "stepOfListingType.propertyType.label",
    },
    PROPERTY_CATEGORY_TYPE_CODE_MANDATORY: {
      step: "listingDetails",
      field: "stepOfListingType.categoryType.label",
    },
    PROPERTY_GROUP_TYPE_CODE_MANDATORY: {
      step: "listingDetails",
      field: "stepOfListingType.categoryType.label",
    },
    PROPERTY_NO_MANDATORY: {
      step: "listingDetails",
      field: "stepOfListingType.referenceNum.label",
    },
    IS_AUCTION_MANDATORY: {
      step: "listingDetails",
      field: "stepOfListingType.auction.field",
    },
    AUCTION_DATE_MANDATORY: {
      step: "listingDetails",
      field: "stepOfListingType.auctionDate.label",
    },
    IS_CO_AGENCY_MANDATORY: {
      step: "listingDetails",
      field: "stepOfListingType.coAgency.field",
    },
    STOREY_CODE_MANDATORY: {
      step: "listingDetails",
      field: "stepOfListingType.storey.label",
    },

    LOCATION_MANDATORY: {
      step: "location",
      field: `stepOfLocation.${FIELDS.buildingName}.label`,
    },
    LOCATION_LEVEL_1_MANDATORY: {
      step: "location",
      field: `stepOfLocation.${FIELDS.state}.label`,
    },
    LOCATION_LEVEL_1_ID_MANDATORY: {
      step: "location",
      field: `stepOfLocation.${FIELDS.state}.label`,
    },
    LOCATION_LEVEL_2_MANDATORY: {
      step: "location",
      field: `stepOfLocation.${FIELDS.city}.label`,
    },
    LOCATION_LEVEL_2_ID_MANDATORY: {
      step: "location",
      field: `stepOfLocation.${FIELDS.city}.label`,
    },
    LOCATION_LEVEL_3_ID_MANDATORY: {
      step: "location",
      field: `stepOfLocation.${FIELDS.township}.label`,
    },
    LOCATION_LEVEL_4_MANDATORY: {
      step: "location",
      field: `stepOfLocation.${FIELDS.buildingName}.label`,
    },
    LOCATION_LEVEL_5_MANDATORY: {
      step: "location",
      field: `stepOfLocation.${FIELDS.buildingName}.label`,
    },
    LOCATION_LEVEL_5_ID_MANDATORY: {
      step: "location",
      field: `stepOfLocation.${FIELDS.buildingName}.label`,
    },
    LOCATION_ADDRESS_MANDATORY: {
      step: "location",
      field: `stepOfLocation.${FIELDS.address}.label`,
    },
    LOCATION_HIDE_UNIT_FLOOR_MANDATORY: {
      step: "location",
      field: `stepOfLocation.${FIELDS.hiddenAddress}.label`,
    },
    LOCATION_COORDINATES_MANDATORY: { step: "location", field: `` },
    LOCATION_HIDE_CAR_PARK_NO_MANDATORY: { step: "location", field: `` },
    INVALID_LOCATION_POSTAL_CODE: {
      step: "location",
      field: `stepOfLocation.${FIELDS.postCode}.label`,
    },

    SALE_PRICE_MANDATORY: {
      step: "propertyDetails",
      field: `stepOfPropertyDetails.${FIELDS.salePrice}.field`,
    },
    RENT_PRICE_MANDATORY: {
      step: "propertyDetails",
      field: `stepOfPropertyDetails.${FIELDS.rentPrice}.field`,
    },
    SALEABLE_AREA_MANDATORY: {
      step: "propertyDetails",
      field: `stepOfPropertyDetails.${FIELDS.builtArea}.field`,
    },
    SALEABLE_AREA_MEASUREMENT_CODE_MANDATORY: {
      step: "propertyDetails",
      field: `stepOfPropertyDetails.${FIELDS.builtArea}.field`,
    },
    GROSS_AREA_MANDATORY: {
      step: "propertyDetails",
      field: `stepOfPropertyDetails.${FIELDS.landArea}.field`,
    },
    GROSS_AREA_MEASUREMENT_CODE_MANDATORY: {
      step: "propertyDetails",
      field: `stepOfPropertyDetails.${FIELDS.landArea}.field`,
    },
    BEDROOM_MANDATORY: {
      step: "propertyDetails",
      field: `stepOfPropertyDetails.${FIELDS.bedrooms}.label`,
    },
    MEASUREMENT_CODE_MANDATORY: {
      step: "propertyDetails",
      field: `stepOfPropertyDetails.${FIELDS.unitType}.label`,
    },
    SALEABLE_AREA_VERIFIED_MANDATORY: { step: "propertyDetails", field: "" },
    SALEABLE_AREA_DIMENSION_WIDTH_MANDATORY: {
      step: "propertyDetails",
      field: `stepOfPropertyDetails.${FIELDS.builtAreaLength}.label`,
    },
    SALEABLE_AREA_DIMENSION_LENGTH_MANDATORY: {
      step: "propertyDetails",
      field: `stepOfPropertyDetails.${FIELDS.builtAreaWidth}.label`,
    },
    GROSS_AREA_DIMENSION_LENGTH_MANDATORY: {
      step: "propertyDetails",
      field: `stepOfPropertyDetails.${FIELDS.landAreaLength}.label`,
    },
    GROSS_AREA_DIMENSION_WIDTH_MANDATORY: {
      step: "propertyDetails",
      field: `stepOfPropertyDetails.${FIELDS.landAreaWidth}.label`,
    },
    LAND_TITLE_TYPE_CODE_MANDATORY: {
      step: "propertyDetails",
      field: `stepOfPropertyDetails.${FIELDS.landTitleType}.label`,
    },
    TITLE_TYPE_CODE_MANDATORY: {
      step: "propertyDetails",
      field: `stepOfPropertyDetails.${FIELDS.titleType}.label`,
    },
    LISTING_EXCLUSIVITY_CODE_MANDATORY: {
      step: "propertyDetails",
      field: `stepOfPropertyDetails.${FIELDS.unexpiredYear}.label`,
    },
    BATHROOM_MANDATORY: {
      step: "propertyDetails",
      field: `stepOfPropertyDetails.${FIELDS.bathrooms}.label`,
    },
    CARPARK_MANDATORY: {
      step: "propertyDetails",
      field: `stepOfPropertyDetails.${FIELDS.carpark}.label`,
    },
    TENURE_CODE_MANDATORY: {
      step: "propertyDetails",
      field: `stepOfPropertyDetails.${FIELDS.tenure}.label`,
    },

    PHOTO_MANDATORY: {
      step: "descriptionAndMedia",
      field: `stepOfDescriptionAndMedia.media.${FIELDS.images}.label`,
    },
    RICHMEDIA_TYPE_MANDATORY: { step: "descriptionAndMedia", field: `` },
    IMAGE_TYPE_MANDATORY: {
      step: "descriptionAndMedia",
      field: `stepOfDescriptionAndMedia.media.${FIELDS.images}.label`,
    },
  };
